export var TABLE_SIZES = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
export var TABLE_SORT_DIRECTIONS = {
  ascending: 'ascending',
  descending: 'descending',
  none: 'none'
};